import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { useServiceHealth } from '@/hooks/useAdminMonitoring';
import { formatBytes } from '@/utils/formatters';
import { HardDrive } from 'lucide-react';

export function MinioMetrics() {
  const { data } = useServiceHealth();
  const minio = data?.services?.minio ?? data?.services?.storage;
  const isUp = minio?.status === 'up' || minio?.status === 'healthy';
  const details = minio?.['details'] as Record<string, unknown> | undefined;
  const storageUsed = (details?.storageUsed ?? minio?.['storageUsed']) as number | undefined;

  return (
    <Card>
      <CardHeader title="MinIO (S3)" />
      <CardContent>
        <div className="flex items-center gap-3">
          <HardDrive className={`h-8 w-8 ${isUp ? 'text-success-500' : 'text-danger-500'}`} />
          <div className="flex-1">
            <p className="text-sm font-medium text-neutral-700 dark:text-neutral-200">Stockage</p>
            <p className="text-lg font-bold text-neutral-900 dark:text-neutral-100">
              {storageUsed != null ? formatBytes(storageUsed) : '--'}
            </p>
          </div>
          {minio && (
            <Badge variant={isUp ? 'success' : 'danger'}>
              {isUp ? 'En ligne' : 'Hors ligne'}
            </Badge>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
